export default __webpack_public_path__ + "static/MAI-Labs-68586d230018981b5faebdb5d5470628.svg";